module.exports = __webpack_public_path__ + "img/filter.a81c0992.svg";